"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_svg_1 = __importDefault(require("@doordash/component-svg"));
var design_language_1 = require("@doordash/design-language");
var lodash_get_1 = __importDefault(require("lodash.get"));
var React = __importStar(require("react"));
/* tslint:disable:max-line-length */
var CardReentry = function () {
    var theme = React.useContext(design_language_1.ThemingContext);
    var strokeColor = lodash_get_1["default"](theme, 'Colors.TextAction', design_language_1.Colors.SystemRed60);
    return (React.createElement(component_svg_1["default"], { width: 48, height: 49, viewBox: "0 0 48 49", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M 39.876 17.397 L 11.875 17.397 C 10.77 17.397 9.875 18.293 9.875 19.397 L 9.875 35.58 C 9.875 36.684 10.77 37.58 11.875 37.58 L 39.876 37.58 C 40.981 37.58 41.876 36.684 41.876 35.58 L 41.876 19.397 C 41.876 18.293 40.981 17.397 39.876 17.397 Z", fill: "white", stroke: "white", "stroke-width": "2" }),
        React.createElement("path", { d: "M 40.785 12.039 L 7.744 12.039 C 6.27 12.039 5.076 13.287 5.076 14.826 L 5.076 34.763 C 5.076 36.303 6.27 37.55 7.744 37.55 L 40.785 37.55 C 42.259 37.55 43.453 36.303 43.453 34.763 L 43.453 14.826 C 43.453 13.287 42.259 12.039 40.785 12.039 Z", fill: "white", stroke: strokeColor, "stroke-width": "2" }),
        React.createElement("path", { d: "M 5.813 18.602 L 42.252 18.602", stroke: strokeColor, "stroke-width": "2", "stroke-linecap": "square" }),
        React.createElement("path", { d: "M 35.982 27.443 L 31.041 27.443 C 29.336 27.443 27.954 28.807 27.954 30.489 C 27.954 32.172 29.336 33.535 31.041 33.535 L 35.982 33.535 C 37.687 33.535 39.069 32.172 39.069 30.489 C 39.069 28.807 37.687 27.443 35.982 27.443 Z", stroke: strokeColor, "stroke-width": "2" })));
};
/* tslint:enable:max-line-length */
exports["default"] = CardReentry;
